import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Layout, Menu } from 'antd'
import { UserOutlined } from '@ant-design/icons'

import assets from '../../../../../assets/images'

const { Header } = Layout

const TopMenu = ({ userEmail }) => {
  const items = [
    {
      children: [
        {
          key: 'changePassword',
          label: <Link to="/change-password">Change Password</Link>,
        },
        {
          key: 'divider',
          type: 'divider',
        },
        {
          key: 'logout',
          label: <Link to="/logout">Logout</Link>,
        },
      ],
      icon: <UserOutlined />,
      key: 'userMenu',
      label: <span>{userEmail}</span>,
      style: {
        marginLeft: 'auto',
      },
    },
  ]

  return (
    <div>
      <Header style={{ alignItems: 'center', display: 'flex', padding: 0 }}>
        <Link style={{ display: 'flex' }} to="/">
          <img
            alt="Loop logo"
            src={assets.loopLogo}
            style={{
              height: '45px',
            }}
          />
        </Link>

        <Menu
          defaultSelectedKeys={['2']}
          items={items}
          mode="horizontal"
          style={{ flex: 1, minWidth: 0 }}
          theme="dark"
        />
      </Header>
    </div>
  )
}

TopMenu.propTypes = {
  userEmail: PropTypes.string,
}

export default TopMenu
